export const TRIP_INFORMATION_SET_DURATION = 'TRIP_INFORMATION_SET_DURATION';
export const DEFAULT_TRIP_DURATION = 7;
export const DEFAULT_NO_DURATION = null;
